<template>
  <proa-modal
    :modal="modal"
    :title="$t('models.taskCard.attributes.description')"
    @close="$emit('close')"
  >
    <proa-input
      v-model="innerDescription"
      type="textarea"
      dark
    />
    <template slot="footer">
      <proa-button
        @click.native="$emit('close')"
        class="default-button-width mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        @click.native="$emit('onUpdateDescription', innerDescription)"
        class="default-button-width"
      >
        {{ $t('common.ok') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
export default {
  name: 'EditProjectTaskCardDescriptionModal',
  props: {
    description: String,
    modal: Boolean
  },
  data() {
    return {
      innerDescription: ''
    }
  },
  methods: {
    initDescription: function() {
      this.innerDescription = this.description
    }
  },
  watch: {
    modal: function(value) {
      if (!value) return
      this.initDescription()
    }
  }
}
</script>
